<footer>
  <div class="row">
    <div class="column medium-4">
      <div class="address">
        <strong>دفتر مرکزی</strong>
        <address>
          تهران، خیابان خالد اسلامبولی (وزرا)، خیابان احمدیان (پانزدهم)، پلاک
          ۲۴، واحد ۶۰۱
        </address>
        <dl>
          <dd>کد پستی:</dd>
          <dt>۱۵۱۳۸۱۳۵۲۰</dt>
          <dd>تلفن:</dd>
          <dt>٨۵۵۱۰ ۰۲۱</dt>
          <dd>پست الکترونیک:</dd>
          <dt>info@aban.capital</dt>
        </dl>
      </div>
      <div class="enamad text-center">
        <a referrerpolicy="origin" target="_blank" href="https://trustseal.enamad.ir/?id=304756&amp;Code=uGPd7BGHQXi0sBOVzC0M"><img referrerpolicy="origin" src="https://Trustseal.eNamad.ir/logo.aspx?id=304756&amp;Code=uGPd7BGHQXi0sBOVzC0M" alt="" style="cursor:pointer" id="uGPd7BGHQXi0sBOVzC0M"></a>
        
      </div>
    </div>
    <div class="column medium-4">
      <div class="work-time">
        <strong>ساعات کاری</strong>
        <dl>
          <dd>شنبه تا چهار شنبه از ساعت ۷:۳۰ الی ۱۶:۳۰</dd>
        </dl>
      </div>
      <div class="info">
        <strong>بیانیه رفع مسئولیت</strong>
        <p></p>
        <p>
          قبل از استفاده از محتوی و خدمات این سایت به دقت این بیانیه را مطالعه
          فرمایید.
        </p>
        <p></p>
        <a  routerLink="/disclaimer">ادامه</a>
      </div>
    </div>
    <div class="column medium-4">
      <div>
        <strong style="border: 0px none">پیام شما</strong>
        <div
          id="iphorm-outer-626ddc5107947"
          class="iphorm-outer iphorm-outer-4 iphorm-responsive"
        >
          <form
            id="iphorm-626ddc5107947"
            class="iphorm iphorm-form-4"
            action="/#iphorm-626ddc5107947"
            (ngSubmit)="submit(form)"
            #form="ngForm"
            method="post"
            enctype="multipart/form-data"
            novalidate="novalidate"
          >
            <div class="iphorm-inner iphorm-inner-4">
              <input type="hidden" name="iphorm_id" value="4" />
              <input type="hidden" name="iphorm_uid" value="626ddc5107947" />

              <input type="hidden" name="post_id" value="2942" />
              <input type="hidden" name="post_title" value="تست" />
              <div class="iphorm-success-message iphorm-hidden"></div>
              <div class="iphorm-elements iphorm-elements-4 iphorm-clearfix">
                <div
                  class="iphorm-element-wrap iphorm-element-wrap-text iphorm_4_1-element-wrap iphorm-clearfix iphorm-labels-inside iphorm-element-required"
                >
                  <div
                    class="iphorm-element-spacer iphorm-element-spacer-text iphorm_4_1-element-spacer"
                  >
                    <label
                      *ngIf="!nameFamily.value"
                      for="nameFamily"
                      class="iphorm_4_1-outer-label"
                      >نام و نام خانوادگی<span class="iphorm-required"
                        >(*)</span
                      ></label
                    >
                    <div
                      class="iphorm-input-wrap iphorm-input-wrap-text iphorm_4_1-input-wrap"
                    >
                      <input
                        #nameFamily="ngModel"
                        ngModel
                        class="iphorm-element-text iphorm_4_1"
                        id="nameFamily"
                        type="text"
                        required
                        name="nameFamily"
                        value=""
                        style="
                          -webkit-appearance: none;
                          -moz-appearance: none;
                          border-radius: 0;
                          background-color: rgb(255, 255, 255);
                          border-style: solid;
                          border-width: 1px;
                          border-color: rgb(204, 204, 204);
                          box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
                          color: rgba(0, 0, 0, 0.75);
                          display: block;
                          font-family: inherit;
                          font-size: 0.875 rem;
                          height: 2.3125 rem;
                          margin: 0 0 1 rem 0;
                          padding: 0.5 rem;
                          width: 100%;
                          -webkit-box-sizing: border-box;
                          -moz-box-sizing: border-box;
                          box-sizing: border-box;
                          -webkit-transition: border-color 0.15s linear,
                            background 0.15s linear;
                          -moz-transition: border-color 0.15s linear,
                            background 0.15s linear;
                          -ms-transition: border-color 0.15s linear,
                            background 0.15s linear;
                          -o-transition: border-color 0.15s linear,
                            background 0.15s linear;
                          transition: border-color 0.15s linear,
                            background 0.15s linear;
                        "
                      />
                    </div>
                    <div class="iphorm-errors-wrap iphorm-hidden">
                      <div
                        [hidden]="
                          nameFamily.valid ||
                          (nameFamily.pristine && !form.submitted)
                        "
                        class="iphorm-errors-wrap"
                      >
                        <div class="iphorm-errors-list iphorm-clearfix">
                          <div class="iphorm-error">
                            لطفا نام و نام خانوادگی خود را وارد نمایید.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="iphorm-element-wrap iphorm-element-wrap-text iphorm_4_5-element-wrap iphorm-clearfix iphorm-labels-inside iphorm-element-required"
                >
                  <div
                    class="iphorm-element-spacer iphorm-element-spacer-text iphorm_4_5-element-spacer"
                  >
                    <label
                      *ngIf="!email.value"
                      for="email"
                      class="iphorm_4_5-outer-label"
                      >پست الکترونیک<span class="iphorm-required"
                        >(*)</span
                      ></label
                    >
                    <div
                      class="iphorm-input-wrap iphorm-input-wrap-text iphorm_4_5-input-wrap"
                    >
                      <input
                        #email="ngModel"
                        ngModel
                        class="iphorm-element-text iphorm_4_5"
                        id="email"
                        type="email"
                        required
                        name="email"
                        value=""
                        style="
                          -webkit-appearance: none;
                          -moz-appearance: none;
                          border-radius: 0;
                          background-color: rgb(255, 255, 255);
                          border-style: solid;
                          border-width: 1px;
                          border-color: rgb(204, 204, 204);
                          box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
                          color: rgba(0, 0, 0, 0.75);
                          display: block;
                          font-family: inherit;
                          font-size: 0.875 rem;
                          height: 2.3125 rem;
                          margin: 0 0 1 rem 0;
                          padding: 0.5 rem;
                          width: 100%;
                          -webkit-box-sizing: border-box;
                          -moz-box-sizing: border-box;
                          box-sizing: border-box;
                          -webkit-transition: border-color 0.15s linear,
                            background 0.15s linear;
                          -moz-transition: border-color 0.15s linear,
                            background 0.15s linear;
                          -ms-transition: border-color 0.15s linear,
                            background 0.15s linear;
                          -o-transition: border-color 0.15s linear,
                            background 0.15s linear;
                          transition: border-color 0.15s linear,
                            background 0.15s linear;
                        "
                      />
                    </div>
                    <div class="iphorm-errors-wrap iphorm-hidden">
                      <div
                        [hidden]="
                          email.valid || (email.pristine && !form.submitted)
                        "
                        class="iphorm-errors-wrap"
                      >
                        <div class="iphorm-errors-list iphorm-clearfix">
                          <div class="iphorm-error">
                            لطفا پست الکترونیکی خود را وارد نمایید.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="iphorm-element-wrap iphorm-element-wrap-textarea iphorm_4_3-element-wrap iphorm-clearfix iphorm-labels-inside iphorm-element-required"
                  >
                    <div
                      class="iphorm-element-spacer iphorm-element-spacer-textarea iphorm_4_3-element-spacer"
                    >
                      <label
                        *ngIf="!message.value"
                        for="message"
                        class="iphorm_4_3-outer-label"
                        >متن پیام<span class="iphorm-required">(*)</span></label
                      >
                      <div
                        class="iphorm-input-wrap iphorm-input-wrap-textarea iphorm_4_3-input-wrap"
                      >
                        <textarea
                          #message="ngModel"
                          required
                          ngModel
                          class="iphorm-element-textarea iphorm_4_3"
                          id="message"
                          name="message"
                          style="
                            -webkit-appearance: none;
                            -moz-appearance: none;
                            border-radius: 0;
                            background-color: rgb(255, 255, 255);
                            border-style: solid;
                            border-width: 1px;
                            border-color: rgb(204, 204, 204);
                            box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
                            color: rgba(0, 0, 0, 0.75);
                            display: block;
                            font-family: inherit;
                            font-size: 0.875 rem;
                            height: 2.3125 rem;
                            margin: 0 0 1 rem 0;
                            padding: 0.5 rem;
                            width: 100%;
                            -webkit-box-sizing: border-box;
                            -moz-box-sizing: border-box;
                            box-sizing: border-box;
                            -webkit-transition: border-color 0.15s linear,
                              background 0.15s linear;
                            -moz-transition: border-color 0.15s linear,
                              background 0.15s linear;
                            -ms-transition: border-color 0.15s linear,
                              background 0.15s linear;
                            -o-transition: border-color 0.15s linear,
                              background 0.15s linear;
                            transition: border-color 0.15s linear,
                              background 0.15s linear;
                          "
                          rows="5"
                          cols="25"
                        ></textarea>
                      </div>
                      <div class="iphorm-errors-wrap iphorm-hidden"></div>
                    </div>
                    <div
                      [hidden]="
                        message.valid || (message.pristine && !form.submitted)
                      "
                      class="iphorm-errors-wrap"
                    >
                      <div class="iphorm-errors-list iphorm-clearfix">
                        <div class="iphorm-error">
                          راجع به پیام خود توضیح دهید.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <app-captcha [form]="form"></app-captcha>
                <!-- <div
                                    class="iphorm-element-wrap iphorm-element-wrap-captcha iphorm_4_4-element-wrap iphorm-clearfix iphorm-labels-inside iphorm-element-required">
                                    <div
                                        class="iphorm-element-spacer iphorm-element-spacer-captcha iphorm_4_4-element-spacer">
                                        <label for="iphorm_4_4_626ddc5107947" class="iphorm_4_4-outer-label">لطفا متن
                                            زیر را وارد نمایید<span class="iphorm-required">(*)</span></label>
                                        <div class="iphorm-input-wrap iphorm-input-wrap-captcha iphorm_4_4-input-wrap">
                                            <input class="iphorm-element-captcha  iphorm_4_4"
                                                id="iphorm_4_4_626ddc5107947" type="text" name="iphorm_4_4" value=""
                                                style="-webkit-appearance: none;-moz-appearance: none;border-radius: 0;background-color: rgb(255, 255, 255);border-style: solid;border-width: 1px;border-color: rgb(204, 204, 204);box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);color: rgba(0, 0, 0, 0.75);display: block;font-family: inherit;font-size: 0.875 rem;height: 2.3125 rem;margin: 0 0 1 rem 0;padding: 0.5 rem;width: 100%;-webkit-box-sizing: border-box;-moz-box-sizing: border-box;box-sizing: border-box;-webkit-transition: border-color 0.15s linear, background 0.15s linear;-moz-transition: border-color 0.15s linear, background 0.15s linear;-ms-transition: border-color 0.15s linear, background 0.15s linear;-o-transition: border-color 0.15s linear, background 0.15s linear;transition: border-color 0.15s linear, background 0.15s linear;">
                                        </div>
                                        <div
                                            class="iphorm-captcha-image-wrap iphorm-clearfix iphorm_4_4-captcha-image-wrap">
                                            <div class="ifb-captcha-image-inner">
                                                <img width="115" height="40"
                                                    id="iphorm-captcha-image-iphorm_4_4_626ddc5107947"
                                                    class="iphorm-captcha-image"
                                                    src="https://aban.capital/wp-content/plugins/iphorm-form-builder/includes/captcha.php?c=eyJ1bmlxSWQiOiI2MjZkZGM1MTA3OTQ3IiwidG1wRGlyIjoiXC90bXBcLyIsIm9wdGlvbnMiOnsibGVuZ3RoIjoiNSIsIndpZHRoIjoiMTE1IiwiaGVpZ2h0IjoiNDAiLCJiZ0NvbG91ciI6IiNGRkZGRkYiLCJ0ZXh0Q29sb3VyIjoiIzIyMjIyMiIsImZvbnQiOiJUeXBpc3QudHRmIiwibWluRm9udFNpemUiOiIxMiIsIm1heEZvbnRTaXplIjoiMTkiLCJtaW5BbmdsZSI6IjAiLCJtYXhBbmdsZSI6IjIwIn19&amp;t=1651366993.09"
                                                    alt="CAPTCHA">
                                            </div>
                                        </div>


                                        <div class="iphorm-errors-wrap iphorm-hidden">
                                        </div>
                                    </div>
                                </div> -->
                <div class="iphorm-hidden">
                  <label
                    >این قسمت نباید خالی رها شود.<input
                      type="text"
                      name="iphorm_4_0"
                  /></label>
                </div>
                <div
                  class="iphorm-submit-wrap iphorm-submit-wrap-4 iphorm-clearfix"
                >
                  <div
                    class="iphorm-submit-input-wrap iphorm-submit-input-wrap-4"
                  >
                    <button
                      class="iphorm-submit-element"
                      type="submit"
                      name="iphorm_submit"
                    >
                      <span><em>ارسال</em></span>
                    </button>
                  </div>
                  <div class="iphorm-loading-wrap">
                    <span class="iphorm-loading">لطفا صبر کنید</span>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <div class="copy-right">
    <div class="row">
      <div class="column medium-12">
        <strong>
          © کلیه حقوق این وب سایت متعلق به شرکت سبدگردان آبان می باشد.
        </strong>
      </div>
    </div>
  </div>
</footer>
